import React from "react";
import {
  EuiPageTemplate,
  EuiTitle,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiSpacer,
  EuiText,
  EuiPanel,
} from "@elastic/eui";

const TARouteSelector = ({ onSelectRole, navigate }) => {
  const handleRoleSelection = async (role) => {
    if (onSelectRole) {
      await onSelectRole(role);
    } else {
      console.error("ERROR: onSelectRole prop is missing!");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 999,
        overflow: "auto",
        background: "var(--euiColorEmptyShade)",
      }}
    >
      <EuiPageTemplate panelled style={{ minHeight: "100vh" }}>
        <EuiPageTemplate.Section alignment="center">
          <EuiPanel
            style={{ maxWidth: "900px", margin: "auto" }}
            paddingSize="xl"
          >
            <EuiTitle size="l" style={{ textAlign: "center" }}>
              <h1>Welcome, Teaching Assistant!</h1>
            </EuiTitle>
            <EuiSpacer size="m" />
            <EuiText textAlign="center" color="subdued" size="m">
              <p>
                You serve as a Teaching Assistant. Please select how you'd like
                to continue:
              </p>
            </EuiText>
            <EuiSpacer size="xxl" />
            <EuiFlexGroup
              gutterSize="xl"
              justifyContent="center"
              responsive={false}
            >
              <EuiFlexItem
                grow={false}
                style={{ minWidth: "320px", maxWidth: "320px" }}
              >
                <EuiCard
                  layout="vertical"
                  icon={<EuiIcon size="xxl" type="wrench" color="primary" />}
                  title="Course Manager"
                  titleSize="s"
                  description="Manage courses, assist with grading, view all student work, and access teaching tools."
                  onClick={() => handleRoleSelection("manager")}
                  selectable={{
                    onClick: () => handleRoleSelection("manager"),
                    isSelected: false,
                  }}
                  style={{
                    cursor: "pointer",
                    height: "100%",
                  }}
                  paddingSize="l"
                />
              </EuiFlexItem>
              <EuiFlexItem
                grow={false}
                style={{ minWidth: "320px", maxWidth: "320px" }}
              >
                <EuiCard
                  layout="vertical"
                  icon={<EuiIcon size="xxl" type="user" color="success" />}
                  title="Student View"
                  titleSize="s"
                  description="Access your enrolled courses, view materials, complete assignments, and participate as a student."
                  onClick={() => handleRoleSelection("student")}
                  selectable={{
                    onClick: () => handleRoleSelection("student"),
                    isSelected: false,
                  }}
                  style={{
                    cursor: "pointer",
                    height: "100%",
                  }}
                  paddingSize="l"
                />
              </EuiFlexItem>
            </EuiFlexGroup>
            <EuiSpacer size="l" />
            <EuiText textAlign="center" color="subdued" size="s">
              <p>
                You can switch between these roles anytime from your profile.
              </p>
            </EuiText>
          </EuiPanel>
        </EuiPageTemplate.Section>
      </EuiPageTemplate>
    </div>
  );
};

export default TARouteSelector;
